import { useCallback } from 'react';
import { useUsageScreen } from '../context/UsageScreenContext';
export function useMergeTrackEventProps() {
  const {
    screen,
    subscreen
  } = useUsageScreen();
  return useCallback(eventProps => {
    const finalEventProps = Object.assign({}, eventProps);
    if (screen && !finalEventProps.screen) {
      finalEventProps.screen = screen;
    }
    if (subscreen && !finalEventProps.subscreen) {
      finalEventProps.subscreen = subscreen;
    }
    return finalEventProps;
  }, [screen, subscreen]);
}